import PropTypes from 'prop-types';

const RentalCarCancellationPolicy = ({ rentalCarItinerary }) =>
  rentalCarItinerary ? (
    <div key={`${rentalCarItinerary.mode}-${rentalCarItinerary.id}`} className="my-2">
      {`Car you have chosen for ${rentalCarItinerary.locationInfo.originLocationCode} - ${rentalCarItinerary.locationInfo.destLocationCode} `}
      has the following refund and change policies:
      <ul className="my-2">
        <li>
          -{' '}
          {rentalCarItinerary.priceInfo.paymentTypeCode === null ||
          rentalCarItinerary.policyInfo.freeCancellation
            ? 'Free '
            : 'Non-free '}
          cancellation.{' '}
          {rentalCarItinerary.priceInfo.paymentTypeCode !== null &&
            'Check vendor rules for more details.'}
        </li>
        <li>
          - {rentalCarItinerary.policyInfo.unlimitedMileage ? 'With ' : 'Without '}
          unlimited mileage
        </li>
        <li>
          - {rentalCarItinerary.policyInfo.mandatoryChauffeur ? 'With ' : 'Without '}
          mandatory chauffer
        </li>
        <li>
          - Provided {rentalCarItinerary.policyInfo.isFairFuelPolicy ? 'with ' : 'without '}
          fair fuel(full-to-full) policy
        </li>
        <li>
          - Provided {rentalCarItinerary.policyInfo.additionalDrivers ? 'with ' : 'without '}
          additional drivers
        </li>
      </ul>
    </div>
  ) : (
    <></>
  );

RentalCarCancellationPolicy.propTypes = {
  rentalCarItinerary: PropTypes.shape().isRequired,
};
export default RentalCarCancellationPolicy;
